// @flow
import * as React from 'react';
import styled from "styled-components";

import type { TRound } from '../../modules/types';
import { OneColumnLayout, PageTitle, AdsContainer, Ad } from '../../components';
import { LeagueManagerComponent } from '../../components/utils/LeagueManager/index';
import RegenerateLeagues from '../../components/RegenerateLeagues';
import LeagueCreateForm from './leaguesCreate/LeaguesCreateForm';

type Props = {
	handleSubmit: Function,
	rounds_list: Array<Object>,
	match: {
		params: {
			regenerate_league_id: number
		}
	}
}

type FormProps = Props & {
	selected_round: TRound
}

const PageTitleStyled = styled(PageTitle)`
	margin-top: 1em;
`;

export const LeagueCreate = (props: Props) => (
	<div>
		<AdsContainer>
			<Ad
				adUnit='create-a-league'
				size='top'
			/>
		</AdsContainer>
		<LeagueManagerComponent from="create">
			{({ rounds_list, handleSubmit, ...props }: FormProps) => (
				<OneColumnLayout>
					<PageTitleStyled>Create a League</PageTitleStyled>
					<RegenerateLeagues />
					<LeagueCreateForm
						{...props}
						onSubmit={handleSubmit}
						rounds={rounds_list}
						regenerate_league_id={props.match.params.regenerate_league_id}
					/>
				</OneColumnLayout>
			)}
		</LeagueManagerComponent>
		<AdsContainer>
			<Ad
				adUnit='myleagues'
				size='bottom'
			/>
		</AdsContainer>
	</div>
);

export default LeagueCreate;


// WEBPACK FOOTER //
// ./src/pages/leagues/LeagueCreate.js